module.exports = __webpack_public_path__ + "img/Buscar_producto.9e99a56e.png";